<template>
  <div class="ap-sub-panel">
    <div class="ap-query-row">
      <el-form :model="crQuery" label-position="left" label-width="190px" class="ap-query" inline @keyup.enter.native="searchCr">
        <el-form-item label="Requirements/Pain Points">
          <el-input clearable size="small" v-model="crQuery.content" placeholder="Please input" style="width:240px"></el-input>
        </el-form-item>
      </el-form>
      <div class="ap-query-actions">
        <el-button type="primary" size="small" @click="searchCr">Search</el-button>
        <el-button size="small" @click="resetCr">Reset</el-button>
        <el-button size="small" :loading="crExportLoading" @click="exportCr">Export</el-button>
        <el-button v-if="hasOperationPermission" type="primary" size="small" @click="addCr">+ Add</el-button>
      </div>
    </div>
    <el-table :data="crTableData" size="small" border style="width:100%" :header-cell-style="{background:'#F5F5F9'}" @sort-change="crSortChange" v-loading="crLoading">
      <el-table-column label="No" width="70" align="center">
        <template slot-scope="scope">{{ (crPage - 1) * crPageSize + scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="content" label="Customer Requirements/Pain Points" min-width="400" sortable="custom" align="left" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="updatedBy" label="Modifier" min-width="140" sortable="custom" align="center"></el-table-column>
      <el-table-column prop="updatedTime" label="Modified Time" min-width="180" sortable="custom" align="center"></el-table-column>
      <el-table-column v-if="hasOperationPermission" label="Operation" width="170" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="modifyCr(scope.row)">Modify</el-button>
          <el-button type="danger" size="mini" @click="deleteCr(scope.row)" style="margin-left:5px">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="ap-pagination">
      <span class="ap-pagination-total">Total {{ crTotal }}</span>
      <el-pagination small layout="prev, pager, next, sizes" :total="crTotal" :current-page.sync="crPage" :page-sizes="[10,20,50]" :page-size.sync="crPageSize" @current-change="v => { crPage = v; loadCrData() }" @size-change="v => { crPageSize = v; crPage = 1; loadCrData() }"></el-pagination>
    </div>

    <!-- CR Add/Modify Modal -->
    <el-dialog :title="crDialogTitle" :visible.sync="crDialogVisible" width="560px" custom-class="cr-dialog">
      <el-form :model="crForm" ref="crForm" label-position="top" :rules="crRules">
        <el-form-item label="Customer Requirements/Pain Points" prop="content">
          <el-input type="textarea" :rows="5" size="small" v-model="crForm.content" placeholder="Please input" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="crDialogVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="crSaving" @click="saveCr" style="margin-left: 6px">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AccountProfileCustomerReq',
  props: {
    accountInfo: { type: Object, default: () => ({}) },
    hasOperationPermission: { type: Boolean, default: false }
  },
  data() {
    return {
      crQuery: { content: '' },
      crTableData: [],
      crLoading: false,
      crTotal: 0,
      crPage: 1,
      crPageSize: 10,
      crSortField: '',
      crSortOrder: '',
      crExportLoading: false,
      crDialogVisible: false,
      crDialogTitle: 'Add',
      crEditId: null,
      crSaving: false,
      crForm: { content: '' },
      crRules: { content: [{ required: true, message: 'Please enter Requirements/Pain Points', trigger: 'blur' }] },
    }
  },
  created() {
    this.loadCrData()
  },
  watch: {
    'accountInfo.id'(newVal) {
      if (newVal) this.loadCrData()
    }
  },
  methods: {
    loadData() {
      this.loadCrData()
    },
    _sortFieldMap(prop) {
      const map = { content: 'content', updatedBy: 'updatedBy', updatedTime: 'updatedTime' }
      return map[prop] || prop
    },
    loadCrData() {
      const id = this.accountInfo.id
      if (!id) return
      let params = {
        pageNum: this.crPage,
        pageSize: this.crPageSize,
        content: this.crQuery.content || undefined,
        sortField: this.crSortField ? this._sortFieldMap(this.crSortField) : undefined,
        sortOrder: this.crSortOrder === 'ascending' ? 'asc' : (this.crSortOrder === 'descending' ? 'desc' : undefined),
      }
      Object.keys(params).forEach(key => { if (params[key] === undefined || params[key] === '') delete params[key] })

      this.crLoading = true
      let url = `${this.$store.state.islhurl}valued-account/profile/${id}/pain-points`
      this.$axios.get(url, { params }).then(res => {
        this.crLoading = false
        const data = res.data
        if (data.code === 200) {
          this.crTableData = data.data || []
          this.crTotal = data.totalSize || 0
        } else {
          this.crTableData = []
          this.crTotal = 0
          this.$message.error(data.msg || 'Failed!')
        }
      }).catch(() => {
        this.crLoading = false
        this.crTableData = []
        this.crTotal = 0
      })
    },
    searchCr() { this.crPage = 1; this.loadCrData() },
    resetCr() { this.crQuery = { content: '' }; this.crSortField = ''; this.crSortOrder = ''; this.crPage = 1; this.loadCrData() },
    crSortChange({ prop, order }) { this.crSortField = order ? (prop || '') : ''; this.crSortOrder = order || ''; this.crPage = 1; this.loadCrData() },
    addCr() { this.crEditId = null; this.crDialogTitle = 'Add Customer Requirements/Pain Points'; this.crForm = { content: '' }; this.crDialogVisible = true; this.$nextTick(() => this.$refs.crForm && this.$refs.crForm.clearValidate()) },
    modifyCr(row) { this.crEditId = row.id; this.crDialogTitle = 'Modify Customer Requirements/Pain Points'; this.crForm = { content: row.content }; this.crDialogVisible = true; this.$nextTick(() => this.$refs.crForm && this.$refs.crForm.clearValidate()) },
    saveCr() {
      this.$refs.crForm.validate(valid => {
        if (!valid) return
        const id = this.accountInfo.id
        this.crSaving = true
        let url = `${this.$store.state.islhurl}valued-account/profile/${id}/pain-points`
        let method = 'post'
        if (this.crEditId) {
          url += `/${this.crEditId}`
          method = 'put'
        }
        this.$axios({ url, method, data: { content: this.crForm.content } }).then(res => {
          this.crSaving = false
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Saved successfully!')
            this.crDialogVisible = false
            this.loadCrData()
          } else {
            this.$message.error(data.msg || 'Save failed!')
          }
        }).catch(() => {
          this.crSaving = false
          this.$message.error('Save failed!')
        })
      })
    },
    deleteCr(row) {
      this.$confirm('Confirm to delete this item?', 'Confirm', { type: 'warning' }).then(() => {
        const id = this.accountInfo.id
        let url = `${this.$store.state.islhurl}valued-account/profile/${id}/pain-points/${row.id}`
        this.$axios.delete(url).then(res => {
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Deleted successfully!')
            this.crPage = 1
            this.loadCrData()
          } else {
            this.$message.error(data.msg || 'Delete failed!')
          }
        }).catch(() => { this.$message.error('Delete failed!') })
      }).catch(() => {})
    },
    exportCr() {
      const id = this.accountInfo.id
      if (!id) return
      this.crExportLoading = true
      let params = {
        content: this.crQuery.content || undefined,
      }
      Object.keys(params).forEach(key => { if (params[key] === undefined || params[key] === '') delete params[key] })
      this.$axios({
        url: `${this.$store.state.islhurl}valued-account/profile/${id}/pain-points/export`,
        method: 'get',
        params,
        responseType: 'blob'
      }).then(response => {
        this.crExportLoading = false
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = 'PainPoints_' + new Date().toISOString().slice(0, 10) + '.xlsx'
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.crExportLoading = false
        this.$message.error('Export failed!')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.ap-sub-panel {
  .ap-query-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 8px;
    .ap-query {
      flex: 1;
      /deep/ .el-form-item { margin-bottom: 0; }
      /deep/ .el-form-item__label { font-size: 13px; color: #1F2937; }
      /deep/ .el-form-item__content .el-input__suffix {
        left: auto;
        right: 10px;
      }
    }
    .ap-query-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-top: 4px;
      white-space: nowrap;
    }
  }
  .ap-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 0 0;
    gap: 12px;
    .ap-pagination-total {
      font-size: 13px;
      color: #6B7280;
    }
  }
}
.el-button+.el-button {
  margin-left: 0;
}
</style>

<style>
.cr-dialog .el-dialog__body {
  padding: 10px 20px;
}
.cr-dialog .el-form--label-top .el-form-item__label {
  line-height: 28px;
  padding-bottom: 0;
  padding-top: 5px;
}
.cr-dialog .el-form-item__error {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/accountDetailTabs/AccountProfileCustomerReq.vue